import React, { useRef } from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import apiCall from "components/Api/api";
import { useNavigate } from "react-router-dom";
import { handleError } from "components/Api/handleError";
import { useMessageContext } from "provider/MessageProvider";
import { todayIST } from "components/Api/common";
import { useAuth } from "provider/AuthContext";
import { useToast } from "provider/ToastProvider";
import TextareaAutosize from 'react-textarea-autosize';
import { useMasterContext } from "provider/MasterProvider";

const QuotationChatModal = () => {
  const { operatorParksOptions, activeUser, quotationFormToggle, formData, errors, messageDispatch } = useMessageContext();
  const { showErrorToast, showSuccessToast, showInfoToast } = useToast();
  const textareaRef = useRef(null);
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { safariCategory } = useMasterContext();
  const maxLength = 1000;

  // const [loading, setLoading] = useState(false);




  const handleClose = () => {
    messageDispatch({ type: "QUOTATION_FORM_TOGGLE", payload: false });
    messageDispatch({ type: 'RESET_QUOTATION_FORM' });
  };


  const validate = () => {
    const newErrors = {};

    if (formData?.safaris < 1) {
      newErrors.safaris = "At least one safari is required.";
    }

    if (formData?.travelers < 1) {
      newErrors.travelers = "At least one traveler is required.";
    }

    if (!formData?.stay_category_id) {
      newErrors.stay_category_id = "Please select accommodation.";
    }

    if (!formData?.start_date) {
      newErrors.start_date = "Start date is required.";
    } else if (formData?.start_date < todayIST) {
      newErrors.start_date = "Start date cannot be in the past.";
    }

    if (!formData?.end_date) {
      newErrors.end_date = "End date is required.";
    } else if (formData?.end_date <= formData?.start_date) {
      newErrors.end_date = "End date must be after start date.";
    }

    if (!formData?.park_id) {
      newErrors.park_id = "Please select a safari park.";
    }

    // Final Quote validation
    if (!formData?.partner_selling_price) {
      newErrors.partner_selling_price = "Final quote is required.";
    } else if (!/^\d+$/.test(formData?.partner_selling_price)) {
      newErrors.partner_selling_price = "Only numbers (0-9) allowed.";
    }

    messageDispatch({
      type: "UPDATE_QUOTATION_ERRORS_DATA",
      payload: newErrors,
    });

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    if (!activeUser?.lead?.id) {
      showInfoToast("There is no lead")
    }
    e.preventDefault();
    const isValid = validate();
    if (!isValid) return;

    try {
      // setLoading(true);
      const formDataSubmit = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '' && value !== 0) {
          formDataSubmit.append(key, value);
        }
      });
      const reqUrl = `chat/send-quote-message/${activeUser?.lead?.id}`;
      const response = await apiCall({
        url: reqUrl,
        method: "POST",
        data: formDataSubmit,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;

      if (apiData?.status === 1) {
        showSuccessToast(apiData?.message);
        messageDispatch({ type: 'RESET_QUOTATION_FORM' });
        messageDispatch({ type: "QUOTATION_FORM_TOGGLE", payload: false });
      } else {
        showErrorToast(apiData?.message)
        console.error("error:", apiData?.message)
      }

    } catch (error) {
      console.error(error);
      handleError(error, logout, navigate);
    } finally {
      // setLoading(false)
    }
  }


  const handleChange = (e) => {
    const { name, value } = e.target;

    messageDispatch({
      type: 'UPDATE_QUOTATION_FORM_DATA',
      payload: { [name]: value }
    });

    if (errors[name]) {
      messageDispatch({
        type: 'UPDATE_QUOTATION_ERRORS_DATA',
        payload: { [name]: '' }
      });
    }
  };
  const handleChangeNotes = (e) => {
    const value = e.target.value.slice(0, maxLength);
    const trimmed = value.trim() ? value : '';

    messageDispatch({
      type: 'UPDATE_QUOTATION_FORM_DATA',
      payload: { addional_notes: trimmed }
    });
  };

  const update = (name, value) => {
    messageDispatch({
      type: 'UPDATE_QUOTATION_FORM_DATA',
      payload: { [name]: value }
    });

    if (errors[name]) {
      messageDispatch({
        type: 'UPDATE_QUOTATION_ERRORS_DATA',
        payload: { [name]: '' }
      });
    }
  };
  return (
    <Modal show={quotationFormToggle} onHide={handleClose} centered backdrop="static">
      <Modal.Body className="p-0 getquote_box-chat">
        <div className=" position-relative" id="memberview">
          <div className="getquote_box">
            <div className="get_free_title2 text-center pb-3">
              <h4>Share itinerary & Quotation</h4>
              <h4>based on the discussion</h4>
            </div>

            <Form onSubmit={handleSubmit}>
              <Row className="gx-2">
                <Col xs={12}>
                  <Row>
                    <Col md={12}>
                      <div className="form-wrapper">
                        <Form.Group className="input-group2">
                          <Form.Label className="m-0 p-0">Safari Park</Form.Label>
                          <Select
                            value={operatorParksOptions?.find((p) => p.value === formData?.park_id) || null}
                            onChange={(selectedOption) => {
                              update("park_id", selectedOption?.value || 0);
                            }
                            }
                            options={operatorParksOptions}
                            isSearchable
                            isClearable
                            placeholder="Select Park"
                            components={{ IndicatorSeparator: () => null }}
                            className=""
                            autoFocus
                          />
                          {errors?.park_id && (
                            <div className="invalid-feedback d-block">{errors.park_id}</div>
                          )}
                        </Form.Group>
                      </div>
                    </Col>
                    {/* Safaris */}
                    <Col sm={6} xs={12}>
                      <div className="form-wrapper mt-3">
                        <Form.Group className="input-group2">
                          <Form.Label className="m-0 p-0">Safaris</Form.Label>
                          <div className="number-input position-relative">
                            <Form.Control
                              type="text"
                              value={formData?.safaris}
                              name='safaris'
                              readOnly
                              className="mb-3 field-safaris required"
                            />
                            <div className="bton_updown">
                              <button
                                type="button"
                                onClick={() => update("safaris", formData?.safaris + 1)}
                              >
                                <i className="fa-solid fa-chevron-up"></i>
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  update("safaris", Math.max(formData?.safaris - 1, 1))
                                }
                              >
                                <i className="fa-solid fa-chevron-down"></i>
                              </button>
                            </div>
                            {errors?.safaris && (
                              <div className="invalid-feedback d-block">{errors.safaris}</div>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </Col>

                    {/* Travelers */}
                    <Col sm={6} xs={12}>
                      <div className="form-wrapper mt-3">
                        <Form.Group className="input-group2">
                          <Form.Label className="m-0 p-0">Travelers</Form.Label>
                          <div className="number-input position-relative">
                            <Form.Control
                              type="text"
                              value={formData?.travelers}
                              readOnly
                            />
                            <div className="bton_updown">
                              <button
                                type="button"
                                onClick={() => update("travelers", formData?.travelers + 1)}
                              >
                                <i className="fa-solid fa-chevron-up"></i>
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  update("travelers", Math.max(formData?.travelers - 1, 1))
                                }
                              >
                                <i className="fa-solid fa-chevron-down"></i>
                              </button>
                            </div>
                            {errors?.travelers && (
                              <div className="invalid-feedback d-block">{errors.travelers}</div>
                            )}
                          </div>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                </Col>

                {/* Accommodation */}
                <Col lg={12}>
                  <div className="form-wrapper">
                    <Form.Group controlId="formAccommodation">
                      <Form.Label className="m-0 p-0">Accommodation</Form.Label>
                      <Form.Select
                        className="mb-1"
                        name="stay_category_id"
                        onChange={handleChange}
                        value={formData?.stay_category_id}
                      >
                        <option
                          value=""
                          className="select2-selection__placeholder"
                          style={{ fontSize: "14px", color: "#9999" }}
                        >
                          Select...
                        </option>
                        {safariCategory?.map((item, index) => (
                          <option value={item?.value} key={index}>
                            {item?.label}
                          </option>
                        ))}
                      </Form.Select>
                      {errors?.stay_category_id && (
                        <div className="invalid-feedback d-block">{errors.stay_category_id}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                {/* Start Date */}
                <Col sm={6} xs={12}>
                  <div className="form-wrapper mt-3">
                    <Form.Group controlId="formStartDate">
                      <Form.Label className="m-0 p-0">Start Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="start_date"
                        value={formData?.start_date}
                        isInvalid={
                          !!errors?.start_date ||
                          (formData?.start_date && formData?.start_date < todayIST)
                        }
                        min={todayIST}
                        onChange={(e) => update("start_date", e.target.value)}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {errors?.start_date && (
                        <div className="invalid-feedback d-block">{errors.start_date}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                {/* End Date */}
                <Col sm={6} xs={12}>
                  <div className="form-wrapper mt-3">
                    <Form.Group controlId="formEndDate">
                      <Form.Label className="m-0 p-0">End Date</Form.Label>
                      <Form.Control
                        type="date"
                        name="end_date"
                        value={formData?.end_date}
                        min={todayIST}
                        onChange={(e) => update("end_date", e.target.value)}
                        onKeyDown={(e) => e.preventDefault()}
                      />
                      {errors?.end_date && (
                        <div className="invalid-feedback d-block">{errors.end_date}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>
                <Col md={12} sm={12} xs={12}>
                  <div className="form-wrapper mt-3">
                    <Form.Label className="m-0 p-0">Additional Notes</Form.Label>
                    <TextareaAutosize
                      ref={textareaRef}
                      name="Chat[addional_notes]"
                      placeholder="Type a Message"
                      className="form-control  hide-scrollbar text-area-commet"
                      value={formData?.addional_notes}
                      onChange={handleChangeNotes}
                      maxLength={maxLength}
                      minRows={3}
                      maxRows={10}
                    />
                  </div>
                </Col>
                <Col sm={12} xs={12}>
                  <div className="form-wrapper mt-3">
                    <Form.Group controlId="formStartDate">
                      <Form.Label className="m-0 p-0">Final Quote</Form.Label>
                      <Form.Control
                        type="text"
                        name="partner_selling_price"
                        placeholder="Rs 000000"
                        value={formData?.partner_selling_price}
                        isInvalid={!!errors?.partner_selling_price}
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onChange={(e) => {
                          const value = e.target.value;
                          // Allow only digits 0-9
                          if (/^\d*$/.test(value)) {
                            update("partner_selling_price", value);
                          }
                        }}
                      />
                      {errors?.partner_selling_price && (
                        <div className="invalid-feedback d-block">{errors.partner_selling_price}</div>
                      )}
                    </Form.Group>
                  </div>
                </Col>


                {/* Submit Button */}
                <Col lg={12} className="pt-lg-0 content-center">
                  <div className="d-flex justify-content-end gap-4">
                    <button type="button" className="close_btns_chat  mb-3 mt-3"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="sent_btn_chat mb-3 mt-3">
                      Share
                    </button>
                  </div>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default QuotationChatModal;
